<template>
  <b-container fluid>
    <b-row class="justify-content-center" v-if="!loaded && loading">
      <b-spinner big label="Loading..."></b-spinner>
    </b-row>

    <b-row v-else-if="loaded">
      <b-container fluid>
        <b-row style="margin-bottom: 8px; text-align: right;">
          <b-col style="text-align: right; padding: 0px;">
            <b-button variant="primary" @click="onAddEventClick()">Dodaj wydarzenie</b-button>
          </b-col>
        </b-row>
        <b-row>
          <vue-cal
            locale="pl"
            :time-from="6*60"
            :time-to="23*60"
            :time-step="20"
            :hide-weekdays="[7]"
            :disable-views="['years', 'year', 'month', 'week', 'day']"
            :events="events"
            :on-event-click="onEventClick"
            @ready="calendarLoaded('ready', $event)"
            @view-change="loadEvents('view-change', $event)"
            class="vuecal--blue-theme"
            id="main-cal"
          >
            <template v-slot:title="{ title, view }">
              Tydzień:
              {{ (view.startDate.getDate() < 10 ? '0' : '') }}{{ view.startDate.getDate() }}.{{ (view.startDate.getMonth() + 1 < 10 ? '0' : '') }}{{ view.startDate.getMonth() + 1 }}.{{ view.startDate.getFullYear() }}
              - {{ (view.endDate.getDate() < 10 ? '0' : '') }}{{ view.endDate.getDate() }}.{{ (view.endDate.getMonth() + 1 < 10 ? '0' : '') }}{{ view.endDate.getMonth() + 1 }}.{{ view.endDate.getFullYear() }}
            </template>
          </vue-cal>
        </b-row>
      </b-container>
    </b-row>

    <b-modal v-model="showAvailabilityModal" size="xl" ok-only>
      <template slot="modal-title">Dostępności</template>
      <b-container>
        <vue-cal
          locale="pl"
          :time-from="6*60"
          :time-to="23*60"
          :time-step="20"
          :hide-weekdays="[7]"
          :disable-views="['years', 'year', 'month', 'week', 'day']"
          :events="availabilityEvents"
          @ready="loadAvailabilityEvents('ready', $event)"
          @view-change="loadAvailabilityEvents('view-change', $event)"
          class="vuecal--blue-theme"
          id="availability-cal"
        >
          <template v-slot:title="{ title, view }">
            Tydzień:
            {{ (view.startDate.getDate() < 10 ? '0' : '') }}{{ view.startDate.getDate() }}.{{ (view.startDate.getMonth() + 1 < 10 ? '0' : '') }}{{ view.startDate.getMonth() + 1 }}.{{ view.startDate.getFullYear() }}
            - {{ (view.endDate.getDate() < 10 ? '0' : '') }}{{ view.endDate.getDate() }}.{{ (view.endDate.getMonth() + 1 < 10 ? '0' : '') }}{{ view.endDate.getMonth() + 1 }}.{{ view.endDate.getFullYear() }}
          </template>
        </vue-cal>
      </b-container>
    </b-modal>

    <b-modal v-model="showEventDetailsModal" ref="eventDetailsModal">
      <template slot="modal-title">{{this.selectedEvent.name}}</template>

      <b-container>
        <b-row>
          <b-col>Data:</b-col>
          <b-col>
            {{this.selectedEvent.start}}
            <div v-if="this.selectedEvent.type < 2">{{this.selectedEvent.end}}</div>
          </b-col>
        </b-row>
        <b-row v-if="this.selectedEvent.type > 1">
          <b-col>{{this.isLector ? "Kursant" : "Lektor"}}:</b-col>
          <b-col>{{this.selectedEvent.interlocutor}}</b-col>
        </b-row>
        <b-row v-if="this.selectedEvent.type > 1">
          <b-col>Telefon:</b-col>
          <b-col>{{this.selectedEvent.phone}}</b-col>
        </b-row>
        <b-row v-if="this.selectedEvent.type > 1">
          <b-col>Skype:</b-col>
          <b-col>
            <a :href="'skype:' + this.selectedEvent.skype + '?call'">{{this.selectedEvent.skype}}</a>
          </b-col>
        </b-row>
        <b-row v-if="this.selectedEvent.price">
          <b-col>Cena zajęć:</b-col>
          <b-col>{{this.selectedEvent.price.toFixed(2)}} PLN</b-col>
        </b-row>
        <b-row v-if="this.subjects != null">
          <b-col>Tematy:</b-col>
          <b-col>{{this.subjects}}</b-col>
        </b-row>
        <b-row v-if="this.currentWords != null">
          <b-col>Słówka:</b-col>
          <b-col>{{this.currentWords}}</b-col>
        </b-row>
        <b-row v-if="this.previousWords != null">
          <b-col>Poprzednie:</b-col>
          <b-col>{{this.previousWords}}</b-col>
        </b-row>
        <b-row v-if="this.selectedEvent.type > 1 && this.selectedEvent.type < 5">
          <b-col>Ocena:</b-col>
          <b-col>{{this.selectedEvent.rating}}</b-col>
        </b-row>
        <b-row v-if="this.selectedEvent.type > 1 && this.selectedEvent.type < 5">
          <b-col>Komentarz:</b-col>
          <b-col>
            <span v-html="this.selectedEvent.comment"></span>
          </b-col>
        </b-row>
        <b-row v-if="this.selectedEvent.type == 5 || this.selectedEvent.type == 6">
          <b-col>Opis dla kursanta:</b-col>
          <b-col>
            <span v-html="this.selectedEvent.descriptionForStudent"></span>
          </b-col>
        </b-row>
        <b-row v-if="this.selectedEvent.type == 5 || this.selectedEvent.type == 6">
          <b-col>Opis dla lektora:</b-col>
          <b-col>
            <span v-html="this.selectedEvent.descriptionForLector"></span>
          </b-col>
        </b-row>
      </b-container>

      <template slot="modal-footer" slot-scope="{ ok }">
        <b-container>
          <b-row>
            <b-col
              style="text-align: left; padding-left: 0px;"
              v-if="selectedEvent.isNoShow && selectedEvent.type < 5"
            >
              <b-button variant="outline-secondary" @click="onEditEventClick(true)">Umów odrabianie</b-button>
            </b-col>
            <b-col style="text-align: left; padding-left: 0px;" v-if="canCancelEvent">
              <b-button variant="danger" @click="cancelEvent()" style="margin-right: 4px;">Odwołaj</b-button>
              <b-button variant="outline-secondary" @click="onEditEventClick()">Edytuj</b-button>
            </b-col>
            <b-col style="text-align: right; padding-right: 0px;">
              <b-button variant="primary" @click="ok()">OK</b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>

    <b-modal v-model="showAddEditEventModal" ref="addEditEventModal" @ok="onOk">
      <template slot="modal-title">{{this.addEditEventModalTitle}}</template>
      <b-form @submit.prevent>
        <b-container>
          <b-row>
            <b-col>Typ wydarzenia:</b-col>
            <b-col>
              <b-form-group>
                <b-form-select
                  v-model="eventType"
                  :options="eventTypes"
                  :disabled="isEditMode || isRedoMode"
                  :state="$v.eventType.$error? false : null"
                ></b-form-select>
                <b-form-invalid-feedback>
                  <div v-if="!$v.eventType.required">To pole jest wymagane</div>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>Lektor:</b-col>
            <b-col>
              <b-form-group>
                <b-form-select
                  v-model="interlocutor"
                  :options="lectors"
                  :disabled="this.selectedEvent.type < 2 || this.isLectorAddEvent"
                  :state="$v.interlocutor.$error? false : null"
                ></b-form-select>
                <b-form-invalid-feedback>
                  <div v-if="!$v.interlocutor.required">To pole jest wymagane</div>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="!this.isEditMode && this.isLector && this.eventType == 0">
            <b-col>Wydarzenie cykliczne:</b-col>
            <b-col>
              <b-form-group>
                <b-form-checkbox
                  switch
                  v-model="isAddPeriodicAvailability"
                  @change="tooglePeriodic()"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="isAddPeriodicAvailability">
            <b-col>Dzień tygodnia:</b-col>
            <b-col>
              <b-form-group>
                <b-form-select
                  v-model="weekDay"
                  :options="weekDays"
                  :state="$v.weekDay.$error? false : null"
                ></b-form-select>
                <b-form-invalid-feedback>
                  <div v-if="!$v.weekDay.required">To pole jest wymagane</div>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="!isAddPeriodicAvailability">
            <b-col>Data:</b-col>
            <b-col>
              <b-form-group>
                <date-picker :config="dateOptions" v-model="startsAtDate" autocomplete="off" />
                <b-form-invalid-feedback>
                  <div v-if="!$v.startsAtDate.required">To pole jest wymagane</div>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="!isAddPeriodicAvailability">
            <b-col>Godzina:</b-col>
            <b-col>
              <b-form-group>
                <b-form-select
                  v-model="startsAtTime"
                  :options="startsAtTimes"
                  :state="$v.startsAtTime.$error? false : null"
                ></b-form-select>
                <b-form-invalid-feedback>
                  <div v-if="!$v.startsAtTime.required">To pole jest wymagane</div>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row
            v-if="(this.selectedEvent.type < 2 || this.isLectorAddEvent) && !isAddPeriodicAvailability"
          >
            <b-col>Godzina:</b-col>
            <b-col>
              <b-form-group>
                <b-form-select
                  v-model="endsAtTime"
                  :options="endsAtTimes"
                  :state="$v.endsAtTime.$error? false : null"
                ></b-form-select>
                <b-form-invalid-feedback>
                  <div v-if="!$v.endsAtTime.required">To pole jest wymagane</div>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="isAddPeriodicAvailability">
            <b-col>Powtarzaj od:</b-col>
            <b-col>
              <b-form-group>
                <date-picker :config="dateOptions" v-model="repeatFromDate" autocomplete="off" />
                <b-form-invalid-feedback>
                  <div v-if="!$v.repeatFromDate.required">To pole jest wymagane</div>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="isAddPeriodicAvailability">
            <b-col>Powtarzaj do:</b-col>
            <b-col>
              <b-form-group>
                <date-picker :config="dateOptions" v-model="repeatToDate" autocomplete="off" />
                <b-form-invalid-feedback>
                  <div v-if="!$v.repeatToDate.required">To pole jest wymagane</div>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="isAddPeriodicAvailability">
            <b-col>Od:</b-col>
            <b-col>
              <b-form-group>
                <b-form-select
                  v-model="repeatFromTime"
                  :options="startsAtTimes"
                  :state="$v.repeatFromTime.$error? false : null"
                ></b-form-select>
                <b-form-invalid-feedback>
                  <div v-if="!$v.repeatFromTime.required">To pole jest wymagane</div>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="isAddPeriodicAvailability">
            <b-col>Do:</b-col>
            <b-col>
              <b-form-group>
                <b-form-select
                  v-model="repeatToTime"
                  :options="endsAtTimes"
                  :state="$v.repeatToTime.$error? false : null"
                ></b-form-select>
                <b-form-invalid-feedback>
                  <div v-if="!$v.repeatToTime.required">To pole jest wymagane</div>
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>

          <template v-if="isEditMode && selectedEvent.price">
            <b-row>
              <b-col>Cena zajęć:</b-col>
              <b-col>{{selectedEvent.price.toFixed(2)}} PLN</b-col>
            </b-row>
            <br />
          </template>
          <b-row v-if="!isEditMode && (isRedoMode || this.eventType == 5 || this.eventType == 6)">
            <b-col>Pobierz opłatę ze środków prepaid:</b-col>
            <b-col>
              <b-form-group>
                <b-form-checkbox switch v-model="chargeFromPrepaid" @change="$v.$reset()"></b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="this.eventType == 5 || this.eventType == 6">
            <b-col>Opis dla kursanta:</b-col>
            <b-col>
              <b-form-group>
                <b-form-textarea v-model="descriptionForStudent" rows="3" autocomplete="off" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="this.eventType == 5 || this.eventType == 6">
            <b-col>Opis dla lektora:</b-col>
            <b-col>
              <b-form-group>
                <b-form-textarea v-model="descriptionForLector" rows="3" autocomplete="off" />
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col></b-col>
            <b-col>
              <a
                @click="onAvailabilityClick"
                style="cursor: pointer; color: #007bff;"
              >Sprawdź dostępność lektora</a>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
    </b-modal>
  </b-container>
</template>

<script>
var qs = require("qs");

import { axios, eventBus } from "@/_infrastructure";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/pl.js";
import "vue-cal/dist/vuecal.css";

export default {
  components: { VueCal },
  data() {
    return {
      validationsObject: {
        startsAtDate: { required },
        startsAtTime: { required },
        eventType: { required },
        interlocutor: { required },
        endsAtTime: {},
        repeatFromDate: {},
        repeatToDate: {},
        repeatFromTime: {},
        repeatToTime: {},
        weekDay: {}
      },
      dateOptions: {
        format: "YYYY-MM-DD",
        locale: "pl",
        useCurrent: true
      },
      addEditEventModalTitle: "",
      isLector: false,
      loading: false,
      loaded: false,
      isAddPeriodicAvailability: false,
      isEditMode: false,
      isRedoMode: false,
      isLectorAddEvent: false,
      showEventDetailsModal: false,
      showAddEditEventModal: false,
      showAvailabilityModal: false,
      canCancelEvent: false,
      isNoShow: false,
      chargeFromPrepaid: false,
      startsAtDate: moment(new Date()).format("YYYY-MM-DD"),
      startsAtTime: null,
      endsAtTime: null,
      startsAtTimes: [{ value: null, text: "..." }],
      endsAtTimes: [],
      eventType: 2,
      eventTypes: [
        { value: 2, text: "Rozmowa" },
        { value: 3, text: "Lekcja" },
        { value: 4, text: "Placement test" },
        { value: 5, text: "Rozmowa dodatkowa" },
        { value: 6, text: "Lekcja dodatkowa" }
      ],
      weekDay: 1,
      weekDays: [
        { value: 1, text: "Poniedziałek" },
        { value: 2, text: "Wtorek" },
        { value: 3, text: "Środa" },
        { value: 4, text: "Czwartek" },
        { value: 5, text: "Piątek" },
        { value: 6, text: "Sobota" }
      ],
      interlocutor: null,
      lectors: [{ value: null, text: "..." }],
      selectedEvent: {},
      events: [],
      availabilityEvents: [],
      lectorsIds: [],
      lectorsProfiles: [],
      from: moment()
        .startOf("week")
        .format("YYYY-MM-DD HH:mm:ss"),
      to: moment()
        .endOf("week")
        .format("YYYY-MM-DD HH:mm:ss"),
      availabilityFrom: null,
      availabilityTo: null,
      repeatFromDate: moment(new Date()).format("YYYY-MM-DD"),
      repeatToDate: moment(new Date()).format("YYYY-MM-DD"),
      repeatFromTime: null,
      repeatToTime: null,
      descriptionForStudent: null,
      descriptionForLector: null,
      subjects: null,
      currentWords: null,
      previousWords: null
    };
  },
  props: ["id"],
  validations() {
    if (this.isAddPeriodicAvailability) {
      this.validationsObject.repeatFromDate = { required };
      this.validationsObject.repeatToDate = { required };
      this.validationsObject.repeatFromTime = { required };
      this.validationsObject.repeatToTime = { required };
      this.validationsObject.startsAtTime = {};
      this.validationsObject.endsAtTime = {};
      this.validationsObject.weekDay = { required };
    } else {
      this.validationsObject.repeatFromDate = {};
      this.validationsObject.repeatToDate = {};
      this.validationsObject.repeatFromTime = {};
      this.validationsObject.repeatToTime = {};
      this.validationsObject.startsAtTime = { required };
      this.validationsObject.endsAtTime = { required };
      this.validationsObject.weekDay = {};
    }

    return this.validationsObject;
  },
  methods: {
    getUserEvents() {
      if (this.id) {
        this.loading = true;

        axios
          .get("/schedule/", {
            params: {
              UserId: this.id,
              From: this.from,
              To: this.to
            }
          })
          .then(response => {
            this.loaded = true;

            this.events = response.data.rows.map(function(item) {
              let event = {
                start: moment(item.startDate).format("YYYY-MM-DD HH:mm"),
                end: moment(item.endDate).format("YYYY-MM-DD HH:mm"),
                id: item.id,
                type: item.type,
                price: item.price
              };

              if (item.type == 5 || item.type == 6) {
                event.content =
                  '<span style="padding-left: 4px;" title="Wydarzenie dodatkowe">📋</span>';
              } else {
                event.content = "";
              }

              if (item.lessonStatus != null) {
                if (item.lessonStatus == 0) {
                  event.content +=
                    '<span style="padding-left: 4px;" title="Wydarzenie oznaczone jako zrealizowane">✅</span>';
                } else {
                  event.content +=
                    '<span style="padding-left: 4px;" title="Wydarzenie oznaczone jako no-show">⛔️</span>';
                }
              }

              if (item.price) {
                event.content += `<span style="padding-left: 4px;" title="Cena zajęć: ${item.price.toFixed(
                  2
                )} PLN">💲</span>`;
              }

              switch (item.type) {
                case 0:
                  event.class = "bg-available";
                  event.name = "Dostępność";
                  event.background = true;
                  break;
                case 1:
                  event.class = "busy";
                  event.name = "Niedostępność";
                  break;
                case 2:
                  event.class = "talk";
                  event.name = "Rozmowa";
                  break;
                case 3:
                  event.class = "lesson";
                  event.name = "Lekcja";
                  break;
                case 4:
                  event.class = "placement-test";
                  event.name = "Placement test";
                  break;
                case 5:
                  event.class = "talk";
                  event.name = "Rozmowa dodatkowa";
                  break;
                case 6:
                  event.class = "lesson";
                  event.name = "Lekcja dodatkowa";
                  break;
              }
              return event;
            });
          })
          .catch(error => eventBus.$emit("unhandled-error", error))
          .then(() => {
            this.loading = false;
          });
      }
    },
    getAvailabilityEvents() {
      if (this.interlocutor != null) {
        this.loading = true;

        axios
          .get("/schedule/availability/", {
            params: {
              UserIds: this.interlocutor,
              From: this.availabilityFrom,
              To: this.availabilityTo,
              MinDuration: "00:20"
            },
            paramsSerializer: params => {
              return qs.stringify(params);
            }
          })
          .then(response => {
            this.loaded = true;

            this.availabilityEvents = response.data[this.interlocutor].map(
              function(item) {
                let event = {
                  start: moment(item.startDate).format("YYYY-MM-DD HH:mm"),
                  end: moment(item.endDate).format("YYYY-MM-DD HH:mm"),
                  class: "available"
                };

                return event;
              }
            );
          })
          .catch(error => eventBus.$emit("unhandled-error", error))
          .then(() => {
            this.loading = false;
          });
      }
    },
    calendarLoaded(state, event) {
      this.loadEvents(state, event);

      if (this.isLector) {
        const mainCal = document.getElementById("main-cal");
        if (mainCal != null) {
          mainCal.classList.add("lector");
        }
      }
    },
    loadEvents(state, event) {
      this.from = moment(event.startDate).format("YYYY-MM-DD HH:mm");
      this.to = moment(event.endDate).format("YYYY-MM-DD HH:mm");

      this.getUserEvents();
    },
    loadAvailabilityEvents(state, event) {
      this.availabilityFrom = moment(event.startDate).format(
        "YYYY-MM-DD HH:mm"
      );
      this.availabilityTo = moment(event.endDate).format("YYYY-MM-DD HH:mm");

      this.getAvailabilityEvents();
    },
    onAvailabilityClick() {
      if (this.interlocutor == null) {
        this.$v.interlocutor.$touch();
        return;
      }

      this.showAvailabilityModal = true;
      this.getAvailabilityEvents();
    },
    onEventClick(event, e) {
      this.selectedEvent = event;
      this.loading = true;
      this.isNoShow = false;

      let now = new Date();
      let eventDate = new Date(this.selectedEvent.start);
      eventDate.setHours(eventDate.getHours());

      this.canCancelEvent = moment(now).unix() <= moment(eventDate).unix();

      axios
        .get("/lessons/event/details/admin/", {
          params: {
            eventId: this.selectedEvent.id,
            userId: this.id
          }
        })
        .then(response => {
          this.loaded = true;
          this.subjects = null;
          this.previousWords = null;
          this.currentWords = null;

          if (response.data.interlocutor != null) {
            this.selectedEvent.interlocutor =
              response.data.interlocutor.firstName +
              " " +
              response.data.interlocutor.lastName;
            this.selectedEvent.phone = response.data.interlocutor.phone;
            this.selectedEvent.skype = response.data.interlocutor.skype;
          }

          this.selectedEvent.price = response.data.price;
          this.selectedEvent.isNoShow = response.data.status == 1;
          this.selectedEvent.rating =
            response.data.rating == null ? "-" : response.data.rating;
          this.selectedEvent.comment =
            response.data.comment == null
              ? "-"
              : response.data.comment.replace("\n", "<br />");
          this.selectedEvent.descriptionForStudent =
            response.data.descriptionForStudent == null ||
            response.data.descriptionForStudent == ""
              ? "-"
              : response.data.descriptionForStudent.replace("\n", "<br />");
          this.selectedEvent.descriptionForLector =
            response.data.descriptionForLector == null ||
            response.data.descriptionForLector == ""
              ? "-"
              : response.data.descriptionForLector.replace("\n", "<br />");

          if (
            response.data.subjects != null &&
            response.data.subjects.length > 0
          ) {
            this.subjects = response.data.subjects
              .map(function(item) {
                return item.title;
              })
              .join(", ");
          }

          if (
            response.data.currentWords != null &&
            response.data.currentWords.length > 0
          ) {
            this.currentWords = response.data.words
              .filter(function(item) {
                return response.data.currentWords.includes(item.id);
              })
              .map(function(item) {
                return item.term;
              })
              .join(", ");
          }

          if (
            response.data.previousWords != null &&
            response.data.previousWords.length > 0
          ) {
            this.previousWords = response.data.words
              .filter(function(item) {
                return response.data.previousWords.includes(item.id);
              })
              .map(function(item) {
                return item.term;
              })
              .join(", ");
          }
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.loading = false;
          this.isNoShow = this.selectedEvent.isNoShow;
          this.showEventDetailsModal = true;
        });

      e.stopPropagation();
    },
    async onAddEventClick() {
      this.$v.$reset();

      this.addEditEventModalTitle = "Nowe wydarzenie";
      this.showAddEditEventModal = true;
      this.isEditMode = false;
      this.isRedoMode = false;
      this.isLectorAddEvent = false;
      this.isAddPeriodicAvailability = false;

      await this.getLectorsIds();
      await this.getLectorsProfiles();

      this.eventType = 2;
      this.interlocutor = null;
      this.startsAtDate = moment(new Date()).format("YYYY-MM-DD");
      this.startsAtTime = null;
      this.endsAtTime = null;
      this.validationsObject.endsAtTime = {};
      this.descriptionForStudent = null;
      this.descriptionForLector = null;

      if (this.isLector) {
        this.eventTypes = [
          { value: 0, text: "Dostępność" },
          { value: 1, text: "Niedostępność" }
        ];
        this.eventType = 0;

        this.interlocutor = parseInt(this.id);
        this.isLectorAddEvent = true;
        this.validationsObject.endsAtTime = { required };
      }

      this.fillAvailableHours();
    },
    async onEditEventClick(isRedoMode = false) {
      this.$v.$reset();
      this.validationsObject.endsAtTime = {};

      if (this.isLector) {
        this.eventTypes = [
          { value: 2, text: "Rozmowa" },
          { value: 3, text: "Lekcja" },
          { value: 4, text: "Placement test" },
          { value: 0, text: "Dostępność" },
          { value: 1, text: "Niedostępność" },
          { value: 5, text: "Rozmowa dodatkowa" },
          { value: 6, text: "Lekcja dodatkowa" }
        ];
        this.eventType = 2;
      }

      this.isEditMode = !isRedoMode;
      this.isRedoMode = isRedoMode;
      this.isLectorAddEvent = false;
      this.isAddPeriodicAvailability = false;
      let currentEvent = this.selectedEvent;

      await this.getLectorsIds();
      await this.getLectorsProfiles();

      this.eventType = this.eventTypes.filter(function(item) {
        return item.value === currentEvent.type;
      })[0].value;

      if (
        currentEvent.interlocutor != null &&
        currentEvent.type > 1 &&
        !this.isLector
      ) {
        this.interlocutor = this.lectors.filter(function(item) {
          return item.text == currentEvent.interlocutor;
        })[0].value;
      } else {
        this.interlocutor = this.id;
      }

      this.startsAtDate = moment(currentEvent.start).format("YYYY-MM-DD");
      this.startsAtTime = moment(currentEvent.start).format("H:mm");

      if (currentEvent.type < 2) {
        this.endsAtTime = moment(currentEvent.end).format("H:mm");
        this.validationsObject.endsAtTime = { required };
      }

      this.descriptionForStudent =
        currentEvent.descriptionForStudent == "-"
          ? ""
          : currentEvent.descriptionForStudent;
      this.descriptionForLector =
        currentEvent.descriptionForLector == "-"
          ? ""
          : currentEvent.descriptionForLector;

      this.$refs["eventDetailsModal"].hide();
      this.addEditEventModalTitle = this.isRedoMode
        ? "Umów odrabianie wydarzenia"
        : "Edytuj wydarzenie";
      this.showAddEditEventModal = true;

      this.fillAvailableHours();
    },
    onOk(e) {
      e.preventDefault();
      this.$v.$touch();

      if (!this.$v.$error) {
        if (this.isEditMode) {
          this.editEvent();
        } else if (this.isRedoMode) {
          this.editEvent(true);
        } else if (this.isAddPeriodicAvailability) {
          this.addPeriodicAvailability();
        } else {
          this.addEvent();
        }
      }
    },
    addEvent() {
      if (!this.$v.$error) {
        this.loading = true;
        let url = "schedule/admin/";
        switch (this.eventType) {
          case 0:
            url += "availability";
            break;
          case 1:
            url += "busy";
            break;
          case 2:
            url += "talk";
            break;
          case 3:
            url += "lesson";
            break;
          case 4:
            url += "placementtest";
            break;
          case 5:
            url += "additionaltalk";
            break;
          case 6:
            url += "additionallesson";
            break;
        }

        let start = moment(
          moment(this.startsAtDate + " " + this.startsAtTime, "YYYY-MM-DD H:mm")
        ).format();
        let end = null;
        if (this.eventType < 2) {
          end = moment(
            moment(this.startsAtDate + " " + this.endsAtTime, "YYYY-MM-DD H:mm")
          ).format();
        }

        axios
          .post(url, {
            studentId: this.id,
            lectorId: this.interlocutor,
            start: start,
            end: end,
            DescriptionForStudent: this.descriptionForStudent,
            DescriptionForLector: this.descriptionForLector,
            chargeFromPrepaid: this.chargeFromPrepaid
          })
          .then(response => {
            let eventId = response.data.id ? response.data.id : response.data;
            let price = response.data.price ? response.data.price : 0;

            let event = {
              start: moment(start).format("YYYY-MM-DD HH:mm"),
              end: moment(start).format("YYYY-MM-DD HH:mm"),
              id: eventId,
              type: this.eventType,
              price: price,
              content: ""
            };

            switch (this.eventType) {
              case 0:
                event.class = "bg-available";
                event.name = "Dostępność";
                event.end = moment(end).format("YYYY-MM-DD HH:mm");
                event.background = true;
                break;
              case 1:
                event.class = "busy";
                event.name = "Niedostępność";
                event.end = moment(end).format("YYYY-MM-DD HH:mm");
                break;
              case 2:
                event.class = "talk";
                event.name = "Rozmowa";
                event.end = moment(event.end)
                  .add("m", 20)
                  .format("YYYY-MM-DD HH:mm");
                break;
              case 3:
                event.class = "lesson";
                event.name = "Lekcja";
                event.end = moment(event.end)
                  .add("m", 60)
                  .format("YYYY-MM-DD HH:mm");
                break;
              case 4:
                event.class = "placement-test";
                event.name = "Placement test";
                event.end = moment(event.end)
                  .add("m", 40)
                  .format("YYYY-MM-DD HH:mm");
                break;
              case 5:
                event.class = "talk";
                event.name = "Rozmowa dodatkowa";
                event.end = moment(event.end)
                  .add("m", 20)
                  .format("YYYY-MM-DD HH:mm");
                event.content =
                  '<span style="padding-left: 4px;" title="Wydarzenie dodatkowe">📋</span>';
                event.descriptionForStudent = this.descriptionForStudent;
                event.descriptionForLector = this.descriptionForLector;
                break;
              case 6:
                event.class = "lesson";
                event.name = "Lekcja dodatkowa";
                event.end = moment(event.end)
                  .add("m", 60)
                  .format("YYYY-MM-DD HH:mm");
                event.content =
                  '<span style="padding-left: 4px;" title="Wydarzenie dodatkowe">📋</span>';
                event.descriptionForStudent = this.descriptionForStudent;
                event.descriptionForLector = this.descriptionForLector;
                break;
            }

            if (event.price) {
              event.content += `<span style="padding-left: 4px;" title="Cena zajęć: ${event.price.toFixed(
                2
              )} PLN">💲</span>`;
            }

            this.events.push(event);
            this.$refs["addEditEventModal"].hide();

            eventBus.$emit("notify-success", "Dodano poprawnie.");
          })
          .catch(error => eventBus.$emit("unhandled-error", error))
          .then(() => {
            this.loading = false;
          });
      }
    },
    addPeriodicAvailability() {
      if (!this.$v.$error) {
        this.loading = true;
        let repeatFrom = moment(
          moment(this.repeatFromDate, "YYYY-MM-DD H:mm")
        ).format();
        let repeatTo = moment(
          moment(this.repeatToDate, "YYYY-MM-DD H:mm")
        ).format();

        axios
          .post("schedule/availability/periodic/", {
            dayOfWeek: this.weekDay,
            repeatFrom: repeatFrom,
            repeatTo: repeatTo,
            start: this.repeatFromTime,
            end: this.repeatToTime,
            lectorId: this.id
          })
          .then(response => {
            let self = this;
            response.data.forEach(function(item) {
              let event = {
                start: moment(item.startDate).format("YYYY-MM-DD HH:mm"),
                end: moment(item.endDate).format("YYYY-MM-DD HH:mm"),
                id: item.id,
                type: item.type,
                class: "bg-available",
                name: "Dostępność",
                background: true
              };

              self.events.push(event);
            });

            this.$refs["addEditEventModal"].hide();

            eventBus.$emit("notify-success", "Dodano poprawnie.");
          })
          .catch(error => eventBus.$emit("unhandled-error", error))
          .then(() => {
            this.loading = false;
          });
      }
    },
    editEvent(isRedoMode = false) {
      let url;
      this.loading = true;

      if (isRedoMode) {
        url = "schedule/admin/redoMeeting";
      } else {
        url = "schedule/admin/";
        switch (this.eventType) {
          case 0:
            url += "availability";
            break;
          case 1:
            url += "busy";
            break;
          case 2:
            url += "talk";
            break;
          case 3:
            url += "lesson";
            break;
          case 4:
            url += "placementtest";
            break;
          case 5:
            url += "additionaltalk";
            break;
          case 6:
            url += "additionallesson";
            break;
        }
      }

      let start = moment(
        moment(this.startsAtDate + " " + this.startsAtTime, "YYYY-MM-DD H:mm")
      ).format();
      let end = null;
      let eventId = this.selectedEvent.id;

      if (this.selectedEvent.type < 2) {
        end = moment(
          moment(this.startsAtDate + " " + this.endsAtTime, "YYYY-MM-DD H:mm")
        ).format();
      }

      axios
        .put(url, {
          id: eventId,
          lectorId: this.interlocutor,
          start: start,
          end: end,
          descriptionForStudent: this.descriptionForStudent,
          descriptionForLector: this.descriptionForLector,
          chargeFromPrepaid: this.chargeFromPrepaid
        })
        .then(response => {
          let event = {
            start: moment(start).format("YYYY-MM-DD HH:mm"),
            end: moment(start).format("YYYY-MM-DD HH:mm"),
            id: eventId,
            type: this.eventType,
            content: "",
            price: this.selectedEvent.price
          };

          switch (this.eventType) {
            case 0:
              event.class = "bg-available";
              event.name = "Dostępność";
              event.end = moment(end).format("YYYY-MM-DD HH:mm");
              event.background = true;
              break;
            case 1:
              event.class = "busy";
              event.name = "Niedostępność";
              event.end = moment(end).format("YYYY-MM-DD HH:mm");
              break;
            case 2:
              event.class = "talk";
              event.name = "Rozmowa";
              event.end = moment(event.end)
                .add("m", 20)
                .format("YYYY-MM-DD HH:mm");
              break;
            case 3:
              event.class = "lesson";
              event.name = "Lekcja";
              event.end = moment(event.end)
                .add("m", 60)
                .format("YYYY-MM-DD HH:mm");
              break;
            case 4:
              event.class = "placement-test";
              event.name = "Placement test";
              event.end = moment(event.end)
                .add("m", 40)
                .format("YYYY-MM-DD HH:mm");
              break;
            case 5:
              event.class = "talk";
              event.name = "Rozmowa dodatkowa";
              event.end = moment(event.end)
                .add("m", 20)
                .format("YYYY-MM-DD HH:mm");
              event.content =
                '<span style="padding-left: 4px;" title="Wydarzenie dodatkowe">📋</span>';
              event.descriptionForStudent = this.descriptionForStudent;
              event.descriptionForLector = this.descriptionForLector;
              break;
            case 6:
              event.class = "lesson";
              event.name = "Lekcja dodatkowa";
              event.end = moment(event.end)
                .add("m", 60)
                .format("YYYY-MM-DD HH:mm");
              event.content =
                '<span style="padding-left: 4px;" title="Wydarzenie dodatkowe">📋</span>';
              event.descriptionForStudent = this.descriptionForStudent;
              event.descriptionForLector = this.descriptionForLector;
              break;
          }

          if (!this.isRedoMode) {
            this.events = this.events.filter(function(item) {
              return item.id != eventId;
            });
          } else {
            event.id = response.data.id;
            event.price = response.data.price;
          }

          if (event.price) {
            event.content += `<span style="padding-left: 4px;" title="Cena zajęć: ${event.price.toFixed(
              2
            )} PLN">💲</span>`;
          }

          if (this.eventType < 2) {
            event.id = response.data.id;
          }

          if (this.isLector) {
            if (this.id == this.interlocutor) {
              this.events.push(event);
            }
          } else {
            this.events.push(event);
          }

          this.$refs["addEditEventModal"].hide();

          this.isRedoMode = false;

          eventBus.$emit("notify-success", "Wyedytowano poprawnie.");
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
        .then(() => {
          this.loading = false;
        });
    },
    cancelEvent() {
      this.$bvModal
        .msgBoxConfirm("Czy na pewno chcesz odwołać to wydarzenie?")
        .then(value => {
          if (value) {
            this.loading = true;
            let url = "schedule/admin/";
            switch (this.selectedEvent.type) {
              case 0:
                url += "availability";
                break;
              case 1:
                url += "busy";
                break;
              case 2:
                url += "talk";
                break;
              case 3:
                url += "lesson";
                break;
              case 4:
                url += "placementtest";
                break;
              case 5:
                url += "additionaltalk";
                break;
              case 6:
                url += "additionallesson";
                break;
            }

            let eventId = this.selectedEvent.id;

            axios
              .delete(url, {
                params: {
                  id: eventId
                }
              })
              .then(() => {
                if (this.selectedEvent.type == 0) {
                  this.getUserEvents();
                } else {
                  this.events = this.events.filter(function(item) {
                    return item.id != eventId;
                  });
                }

                this.$refs["eventDetailsModal"].hide();
              })
              .catch(error => {
                eventBus.$emit("unhandled-error", error);
              })
              .then(() => {
                this.loading = false;
              });
          }
        });
    },
    async getLectorsIds() {
      await axios
        .get("lectors/list/ids/")
        .then(response => {
          this.lectorsIds = response.data;
        })
        .catch(error => {
          eventBus.$emit("unhandled-error", error);
        });
    },
    async getLectorsProfiles() {
      await axios
        .get("lectors/list/profiles", {
          params: {
            ids: this.lectorsIds
          },
          paramsSerializer: params => {
            return qs.stringify(params);
          }
        })
        .then(response => {
          this.lectorsProfiles = response.data;
        })
        .catch(error => {
          eventBus.$emit("unhandled-error", error);
        });
    },
    fillAvailableHours() {
      if (this.startsAtTimes.length > 1 || this.endsAtTimes.length > 1) {
        return;
      }

      let startHour = 6;
      let startMinute = 0;

      while (startHour < 23) {
        this.startsAtTimes.push({
          value: startHour + ":" + (startMinute == 0 ? "00" : startMinute),
          text: startHour + ":" + (startMinute == 0 ? "00" : startMinute)
        });

        if (startHour == 22 && startMinute == 40) {
          break;
        }

        startMinute += 20;

        if (startMinute == 60) {
          startHour++;
          startMinute = 0;
        }
      }

      this.endsAtTimes = this.startsAtTimes.concat(this.endsAtTimes);
      this.endsAtTimes.push({
        value: "23:00",
        text: "23:00"
      });
    },
    tooglePeriodic() {
      this.$v.$reset();
    }
  },
  watch: {
    lectorsProfiles: function() {
      this.lectors = [{ value: null, text: "..." }];
      this.lectors = this.lectors
        .concat(
          this.lectorsProfiles.map(function(item) {
            return {
              value: item.id,
              text: item.firstName + " " + item.lastName
            };
          })
        )
        .sort(function(a, b) {
          if (a.text < b.text) {
            return -1;
          }
          if (a.text > b.text) {
            return 1;
          }
          return 0;
        });
    },
    eventType: function(newValue) {
      if (newValue != 0) {
        this.isAddPeriodicAvailability = false;
      }
    },
    loading: function(newValue) {
      if (newValue) {
        this.loader = this.$loading.show();
      } else {
        this.loader.hide();
      }
    }
  },
  created() {
    this.isLector = this.$route.path.toLowerCase().includes("lector");
    this.getUserEvents();
  }
};
</script>

<style lang="scss">
.vuecal__event.busy {
  background-color: #ffa094 !important;
  color: #000 !important;
}

.vuecal__event.talk {
  background-color: #38ace3 !important;
  color: #fff !important;
}

.vuecal__event.lesson {
  background-color: #fedd94 !important;
  color: #fff !important;
}

.vuecal__event.placement-test {
  background-color: #bce29e !important;
  color: #fff !important;
}

.vuecal__event.available {
  background-color: #fff !important;
  color: #000 !important;
}

.vuecal__event.bg-available {
  background-color: #fff !important;
  color: #000 !important;
  align-items: flex-start !important;
  padding-top: 1em !important;
}

.vuecal__title-bar {
  background-color: #588093 !important;
  color: #fff !important;
}

.lector .vuecal__cell {
  background-color: rgba(0, 0, 0, 0.29) !important;
}

.lector .vuecal__no-event {
  color: #fff !important;
}

.lector .vuecal--blue-theme .vuecal__cell.selected:before {
  border-color: #fff !important;
}

.vuecal__event {
  display: flex;
  justify-content: center;
  align-items: center;
}

.vuecal__event:hover,
.vuecal__event:focus,
.vuecal__event--focus,
.vuecal__event:active {
  z-index: 1 !important;
}

.vuecal__event--background:hover,
.vuecal__event--background:focus,
.vuecal__event--background--focus,
.vuecal__event--background:active {
  z-index: 0 !important;
}

#availability-cal .vuecal__cell {
  background-color: rgba(0, 0, 0, 0.29) !important;
}

#availability-cal .vuecal__no-event {
  color: #fff !important;
}

#availability-cal .vuecal--blue-theme .vuecal__cell.selected:before {
  border-color: #fff !important;
}

.vld-overlay {
  z-index: 9999 !important;
}
</style>